import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Client } from 'src/app/entity/exhibitor';
import { ClientService } from 'src/app/service/client.service';
import { Table } from 'primeng/table';
 declare var jsPDF: any;
@Component({
  selector: 'app-liste-exhibitors',
  templateUrl: './liste-exhibitors.component.html',
  styleUrls: ['./liste-exhibitors.component.css']
})
export class ListeExhibitorsComponent implements OnInit {

  listArchives: Observable<Client[]>;
  listClients: Client[];
  loading: boolean;
  @ViewChild('dt') DataTableVar: Table;
  cols: any[];
  colsExport: any[];
  exportColumns: any[];
  types: { label: string; value: string; }[];
  constructor(private clientService: ClientService) {

  }

  ngOnInit() {
    this.cols = [
      { field: 'raisonSocial', header: 'Raison Social', width: '40%' },

      { field: 'standList', header: 'Stands', width: '10%' },
      { field: 'superficie', header: 'Superficie', width: '100px' },

      { field: 'type', header: 'Type', width: '200px' },

      { field: 'observation', header: 'Note', width: '30%' },
    ];
    this.colsExport = [
      { field: 'raisonSocial', header: 'Raison Social' },

      { field: 'standList', header: 'Stands' },
      { field: 'superficie', header: 'Superficie' },
      { field: 'observation', header: 'Note' },

    ];
    this.types = [
      { label: 'Exposant', value: "E" },
      { label: 'Co-Exposant', value: 'C' },
      { label: 'Exposant Sponsor', value: 'ES' },

    ];


    this.exportColumns = this.colsExport.map(col => ({ title: col.header, dataKey: col.field }));
    this.listArchives = this.clientService.findExhibitors();
    this.loading = true;
    this.listArchives.subscribe(result => {
      this.listClients = result;
    })
  }

  convertType(t: string): string {
    let type: string;
    if (t == "E")
      type = "Exposant"
    else if (t == "ES")
      type = "Exposant Sponsor"
    else if (t == "C")
      type = "Co-Exposant"
    return type;
  }

  exportExcel() {

    const doc = new jsPDF('l');
    doc.filename = "cwxc";
    if (this.DataTableVar.filteredValue)
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.getItems(this.DataTableVar.filteredValue));
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "exhibitor_list");
      });
    else import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.getItems(this.listClients));
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "exhibitor_list");
    });



  }
  exportPdf() {


    const doc = new jsPDF('l');
    doc.filename = "cwxc";
    if (this.DataTableVar.filteredValue)
      doc.autoTable(

        this.exportColumns, this.DataTableVar.filteredValue, {


        margin: { horizontal: 7 },

        columnStyles: { 0: { columnWidth: 80 }, 1: { columnWidth: 70 }, 2: { columnWidth: 40 } }
      });
    else doc.autoTable(
      this.exportColumns, this.listClients, {


      margin: { horizontal: 7 },

      columnStyles: { 0: { columnWidth: 80 }, 1: { columnWidth: 70 }, 2: { columnWidth: 40 } }
    });

    doc.save('Liste des stands.pdf');


  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  getItems(items: Client[]) :Item[]{
    let cars: Item[] = [];

    for (let index = 0; index < items.length; index++) {
      const element = items[index];
      let item = new Item();
      item.RAISON_SOCIAL = element.raisonSocial;
      item.STAND = element.standList;
      item.SUPERFICIE = element.superficie;
      item.NOTE = element.observation;
      cars.push(item);
    }




    return cars;
  }
}

class Item {
  RAISON_SOCIAL: any;
  STAND: any;
  SUPERFICIE:string;
  NOTE:string
}